import { vagon2 } from "../objectsInfo/walls";

export const actionSystem = (entities, { input, time }) => {
  const character = entities.character;


  Object.keys(entities).forEach(key => {
    if (key.startsWith('inter')) {
      const interactive = entities[key];

      const length = Math.sqrt(
        Math.pow(interactive.position.x - character.position.x, 2) +
        Math.pow(interactive.position.y - character.position.y, 2)
      );

      if (length <= 80) {
        interactive.inActiveZone = true
      } else {
        interactive.inActiveZone = false
      }
    }
  });


  return entities;
};
